import { useAtomValue, useSetAtom } from "jotai";

import BottomDrawer from "components/BottomDrawer";
import Button from "components/Button";
import DamagedPartsEstimate from "components/DamagedPartsEstimate";
import Feedback from "components/Feedback";
import Flex from "components/Flex";
import PhoneCallSvg from "components/Illustrations/PhoneCall";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { clientConfigAtom } from "atoms/clientConfig";
import { estimateAtom } from "atoms/estimate";
import { pageDrawerAtom } from "atoms/pageDrawer";
import { useClientTranslation } from "hooks/useClientTranslation";
import { useEventTracking } from "hooks/useEventTracking";
import { payeeFinalisedAtom } from "atoms/payeeFinalised";

import { useStyles } from "../styles";
import { useEffect } from "react";

export const TalkToClaimHandler = () => {
  const { speedyPayment, blockReturnToEstimate = false } = useAtomValue(clientConfigAtom);

  const toggleDrawer = useSetAtom(pageDrawerAtom);
  const { trackEvent } = useEventTracking();
  const { t } = useClientTranslation();

  const { theme } = useStyles();
  const estimate = useAtomValue(estimateAtom);
  const setPayeeFinalised = useSetAtom(payeeFinalisedAtom);
  // Flag payee journey finalised
  useEffect(() => {
    setPayeeFinalised(true);
  }, [setPayeeFinalised]);
  const toggleEstimate = () => {
    toggleDrawer();
    trackEvent({ name: "View initial repair estimate" });
  };

  // Brand colors are used on this SVG so we conditional swap it out if an override is provided
  const Illustration = speedyPayment?.talkToClaimHandler?.illustrations?.main
    ? // eslint-disable-next-line jsx-a11y/alt-text
      () => <img {...speedyPayment?.talkToClaimHandler?.illustrations?.main} />
    : () => <PhoneCallSvg fill={theme.other.primary[60]} role="image" />;

  return (
    <PageLayout contentSpacing="space-between" dataTestId="talkToClaimHandler">
      <Feedback>
        <Flex mb={36}>
          <Illustration />
          <Flex mx={40} align="center">
            <Text as="h1" sizeVariant="xl" weight={500} my={20} align="center">
              {t("offer_declined.header")}
            </Text>
            <Text sizeVariant="md" weight={500} my={20} align="center">
              {t("offer_declined.instruction")}
            </Text>

            {!blockReturnToEstimate && (
              <Button typeVariant="link" style={{ textDecoration: "none", fontWeight: 500 }} onClick={toggleEstimate}>
                {t("global.view_initial_repair_estimate")}
              </Button>
            )}
          </Flex>
        </Flex>
      </Feedback>
      {estimate && (
        <BottomDrawer heading={t("global.view_initial_repair_estimate")} stickyBoxShadow={true}>
          <DamagedPartsEstimate estimate={estimate} />
        </BottomDrawer>
      )}
    </PageLayout>
  );
};
